import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import flatpickr from 'flatpickr';

@Component({
  selector: 'app-multi-datepicker',
  templateUrl: './multi-datepicker.component.html',
  styleUrls: ['./multi-datepicker.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MultiDatepickerComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() placeholder: string;
  @Input() hasError: boolean;
  @Input() submitted: boolean;
  @Input() datepickerStyle: string;
  @Input() defaultDates: Date[] = [];
  @Input() inputId: string;

  @Output() selectedDates = new EventEmitter<Date[]>();

  @ViewChild('myInput', {read: ElementRef}) myInput: ElementRef<HTMLInputElement>;

  private flatpickrInstance: any;
  selectedDatesTitle = '';

  ngAfterViewInit(): void {
    if (this.defaultDates?.length) {
      this.selectedDatesTitle = this.defaultDates
        .map(d => d.toLocaleDateString('nl-BE', {day: '2-digit', month: '2-digit', year: 'numeric'}))
        .join('\n');
    }
    this.flatpickrInstance = flatpickr(this.myInput.nativeElement, {
      mode: 'multiple',
      dateFormat: 'd.m.Y',
      locale: { firstDayOfWeek: 1 },
      defaultDate: this.defaultDates?.length ? this.defaultDates : undefined,
      onChange: (selectedDates: Date[]) => {
        const sorted = [...selectedDates]
          .map(d => { const n = new Date(d); n.setHours(12, 0, 0, 0); return n; })
          .sort((a, b) => a.getTime() - b.getTime());
        this.selectedDatesTitle = sorted
          .map(d => d.toLocaleDateString('nl-BE', {day: '2-digit', month: '2-digit', year: 'numeric'}))
          .join('\n');
        this.selectedDates.emit(sorted);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultDates'] && this.flatpickrInstance) {
      this.flatpickrInstance.setDate(this.defaultDates ?? [], false);
    }
  }

  ngOnDestroy(): void {
    this.flatpickrInstance?.destroy();
  }

  open(): void {
    this.flatpickrInstance?.open();
  }

  clear(): void {
    this.flatpickrInstance?.clear();
  }
}
